import { render } from "./FormIframe.vue?vue&type=template&id=2ef3a7e0"
import script from "./FormIframe.vue?vue&type=script&lang=js"
export * from "./FormIframe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__